module.exports = __webpack_public_path__ + "static/img/5.3135678.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/5.png
// module id = W1vz
// module chunks = 44